var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2856 11.2868C20.0812 11.2868 20.8443 10.9707 21.4069 10.4081C21.9695 9.84549 22.2856 9.08243 22.2856 8.28677C22.2856 7.49114 21.9695 6.72808 21.4069 6.16547C20.8443 5.60285 20.0812 5.28677 19.2856 5.28677C18.49 5.28677 17.727 5.60285 17.1644 6.16547C16.6017 6.72808 16.2856 7.49114 16.2856 8.28677C16.2856 9.08243 16.6017 9.84549 17.1644 10.4081C17.727 10.9707 18.49 11.2868 19.2856 11.2868Z",
    fill: "#D7F4EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58936 1.71429H1.71436V7.875C1.71436 10.9224 4.18478 13.3929 7.23221 13.3929C10.2796 13.3929 12.7501 10.9224 12.7501 7.875V1.71429H10.8751",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01025 13.3929V16.1514C7.01025 19.5393 9.75669 22.2857 13.1446 22.2857C16.5325 22.2857 19.2789 19.5393 19.2789 16.1514V11.2835",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2856 11.2868C20.0812 11.2868 20.8443 10.9707 21.4069 10.4081C21.9695 9.84549 22.2856 9.08243 22.2856 8.28677C22.2856 7.49114 21.9695 6.72808 21.4069 6.16547C20.8443 5.60285 20.0812 5.28677 19.2856 5.28677C18.49 5.28677 17.727 5.60285 17.1644 6.16547C16.6017 6.72808 16.2856 7.49114 16.2856 8.28677C16.2856 9.08243 16.6017 9.84549 17.1644 10.4081C17.727 10.9707 18.49 11.2868 19.2856 11.2868Z",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.2fa5ec495f18546f98397914dcb72876.svg";
export { ForwardRef as ReactComponent };